module.exports = __webpack_public_path__ + "static/media/pro.2860bd18.png";